const getCurrentEnv = () => {
  const { hostname } = window.location;

  if (hostname === "localhost" || hostname.includes("-it")) return "it";
  if (hostname.includes("-dev")) return "dev";
  if (hostname.includes("uat")) return "uat";
  return "prod";
};

export default getCurrentEnv;
